import { useCallback, useEffect, useReducer } from 'react';
import { getAxiosClient } from '#shared/api/axiosClient';
const initialState = {
  records: [],
  meta: {
    pageCount: 1
  },
  isLoading: false,
  error: null
};
const fetchReducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_INIT':
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case 'FETCH_SUCCESS':
      return {
        ...state,
        isLoading: false,
        records: action.payload.records,
        meta: action.payload.meta,
        error: null
      };
    case 'FETCH_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    default:
      throw new Error(`Unsupported action type: ${action.type}`);
  }
};
const useFetchGlossaryTerms = () => {
  const [state, dispatch] = useReducer(fetchReducer, initialState);
  const fetchData = useCallback(async (query = '', activityDraft = null) => {
    dispatch({
      type: 'FETCH_INIT'
    });
    if (query === '' || activityDraft?.businessLineId === null) {
      return;
    }
    try {
      const params = {
        search: query,
        filter: activityDraft.businessLineId
      };
      const axiosClient = getAxiosClient();
      const response = await axiosClient.get('/glossary', {
        params
      });
      dispatch({
        type: 'FETCH_SUCCESS',
        payload: {
          records: response.data.data || [],
          meta: response.data.meta || {}
        }
      });
    } catch (err) {
      dispatch({
        type: 'FETCH_FAILURE',
        payload: {
          error: err.response?.data || 'An error occurred'
        }
      });
    }
  }, [dispatch]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return {
    ...state,
    fetchData
  };
};
export default useFetchGlossaryTerms;